import { render, staticRenderFns } from "./LoadProfileDetails.vue?vue&type=template&id=b53c546c&scoped=true"
import script from "./LoadProfileDetails.vue?vue&type=script&lang=js"
export * from "./LoadProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./LoadProfileDetails.vue?vue&type=style&index=0&id=b53c546c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53c546c",
  null
  
)

export default component.exports